import { gql } from '@apollo/client';

export const CREATE_GOAL = gql`
  mutation CreateGoal($input: CreateGoalInput!) {
    createGoal(input: $input) {
      id
      name
      categoryId
      levelId
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_GOAL = gql`
  mutation UpdateGoal($updateGoalId: ID!, $input: UpdateGoalInput!) {
    updateGoal(id: $updateGoalId, input: $input) {
      id
      name
      categoryId
      levelId
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_GOAL = gql`
  mutation DeleteGoal($deleteGoalId: ID!) {
    deleteGoal(id: $deleteGoalId)
  }
`;

export const LIST_GOALS = gql`
  query ListGoals($page: Int, $limit: Int, $filters: GoalFilterInput) {
    listGoals(page: $page, limit: $limit, filters: $filters) {
      goals {
        id
        name
        categoryId
        levelId
        createdAt
        updatedAt
      }
      total
      page
      limit
      totalPages
    }
  }
`;

export const GET_ALL_CATEGORIES = gql`
  query GetAllCategories {
    getAllCategories {
      id
      name
    }
  }
`;

export const GET_ALL_LEVELS = gql`
  query GetAllLevels {
    getAllLevels {
      id
      name
    }
  }
`;
